/**
 * 实名用户身份 / 委托书审核状态检查
 *
 * 输入：调用方传 axios + token + getUserForUserCenter 响应（outerRes） + 5 个回调
 * 内部完成 axios 调用 + 14-case switch + alert 错误处理 + 调用回调
 *
 * 不引用 this、不引用 localStorage、不改 Vue 实例 data；纯函数。
 *
 * 状态码语义（与 /loginapi/getUserIdentity 接口契约）：
 *   0.无操作   1.未提交任何身份认证  2.政企审核中  3.政企审核被拒绝
 *   4.未上传政企委托书  5.政企委托书审核中  6.政企委托书审核通过  7.政企委托书被拒绝
 *   8：教育审核中  9.教育审核被拒绝
 *   10.未上传教育委托书  11.教育委托书审核中  12.教育委托书审核通过   13.教育委托书被拒绝
 *
 * @param {Object} params
 * @param {Object} params.axios
 * @param {string} params.token
 * @param {Object} params.outerRes       getUserForUserCenter 响应
 * @param {(statusCode: number) => void} params.onStatus
 * @param {() => void} params.onProceed                       status 6 / 12
 * @param {() => void} params.onShowIdentityPicker            status 0 / 1
 * @param {(path: string) => void} params.onNavigate
 *        status 2/3 → '/store/VIPBenefits'，status 8/9 → '/store/OpenEducationalCertification'
 *        (父组件一般在 callback 内包一层 jumpWithPermission('仅实名', ...))
 * @param {(mode: 'not_upload'|'viewing'|'rejected', rejectReason: string) => void} params.onOpenAuthLetterDialog
 *        status 4/5/10/11 → mode='not_upload' / 'viewing'
 *        status 7/13 → mode='rejected' + rejectReason
 */
export async function checkUserCert({
    axios,
    token,
    outerRes,
    onStatus,
    onProceed,
    onShowIdentityPicker,
    onNavigate,
    onOpenAuthLetterDialog,
}) {
    const identityRes = await axios.get('/loginapi/getUserIdentity', {
        headers: { Authorization: 'Bearer ' + token },
    }).catch(() => {
        alert('获取用户认证状态失败，请稍后重试');
        return null;
    });
    if (!identityRes) return null;
    if (Number(identityRes.data.code) !== 200) {
        alert(identityRes.data.message || '获取用户认证状态失败');
        return null;
    }
    const statusCode = Number(identityRes.data.data);
    console.log(`status:${statusCode}`);
    // 先把原始状态写回父组件（用于 isEnterprise 计算 + 透传给 dialog 组件）
    onStatus(statusCode);

    switch (statusCode) {
        case 0:
        case 1:
            onShowIdentityPicker();
            break;
        case 2:
        case 3:
            onNavigate('/store/VIPBenefits');
            break;
        case 4:
            onOpenAuthLetterDialog('not_upload', '');
            break;
        case 5:
            onOpenAuthLetterDialog('viewing', '');
            break;
        case 6:
        case 12:
            onProceed();
            break;
        case 7:
            onOpenAuthLetterDialog(
                'rejected',
                (outerRes && outerRes.data && outerRes.data.data && outerRes.data.data.authorizationLetterRejectReason) || '',
            );
            break;
        case 8:
        case 9:
            onNavigate('/store/OpenEducationalCertification');
            break;
        case 10:
            onOpenAuthLetterDialog('not_upload', '');
            break;
        case 11:
            onOpenAuthLetterDialog('viewing', '');
            break;
        case 13:
            onOpenAuthLetterDialog(
                'rejected',
                (outerRes && outerRes.data && outerRes.data.data && outerRes.data.data.eduAuthorizationLetterRejectReason) || '',
            );
            break;
        default:
            alert('用户认证状态异常，请稍后重试');
            break;
    }
}
